import React, { FC } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import HeroSearchForm from "components/HeroSearchForm/HeroSearchForm";
import { Element } from "react-scroll";
import CoverImage from "images/cover.jpeg";

export interface SectionHeroProps {
	className?: string;
	focus: boolean;
}

const SectionHero: FC<SectionHeroProps> = ({ className = "", focus }) => {
	return (
		<div
			className={`nc-SectionHero flex flex-col relative ${className}`}
			data-nc-id="SectionHero"
		>
			{/* <div className="flex flex-col lg:flex-row"> */}
			<div className="flex flex-col lg:flex-row lg:items-center">
				{/* <div className="flex-shrink-0 lg:w-1/2 flex flex-col items-start space-y-8 sm:space-y-10 pt-11 pb-14 lg:pb-60 xl:pr-14 lg:mr-10 xl:mr-0"> */}
				<div className="text-center lg:text-left flex-shrink-0 lg:w-1/2 flex flex-col items-center lg:items-start space-y-8 sm:space-y-10 pb-14 lg:pb-64 xl:pr-14 lg:mr-10 xl:mr-0">
					<h2 className="font-medium text-4xl md:text-5xl  xl:text-7xl leading-[110%]">
						<span className="">
							<div className="inline -ml-28 md:-ml-32 lg:ml-0">Sewa</div>{" "}
							<div className="text-box play text-sky-500 inline-block relative">
								<div className="absolute opacity-0">Tenda</div>
								<div className="absolute opacity-0">Carrier</div>
								<div className="absolute opacity-0 ">Nesting</div>
								{/* <div className="absolute opacity-0">Kamera</div> */}
							</div>{" "}
							<br></br>
							Ga Pake Ribet!
						</span>{" "}
					</h2>
					<span className="text-base md:text-lg text-neutral-500 dark:text-neutral-400 w-full">
						Disini Pusatnya Sewa Perlengkapan Outdoor Langsung di Berbagai
						Lokasi
					</span>
					<Element name="search" className="absolute"></Element>

					<ButtonPrimary
						className="hidden lg:block"
						// onClick={() => {
						//   scroll.scrollTo("search", {
						//     duration: 1500,
						//     delay: 100,
						//     smooth: true,
						//     offset: 200,
						//   });
						//   setTimeout(() => {
						//     setFocus(true);
						//   }, 2000);
						//   setFocus(false);
						// }}
						href={"/listing"}
					>
						Mulai mencari barang
					</ButtonPrimary>
				</div>
				<div className="flex-grow">
					<img
						className="w-full hidden lg:block "
						src={CoverImage}
						alt="hero"
					/>
				</div>
			</div>

			<div className="z-10 mb-12 lg:mb-0 lg:-mt-40 w-full">
				<HeroSearchForm focus={focus} />
			</div>
		</div>
	);
};

export default SectionHero;
